import {_, React, useCallback, useEffect, useLocalStore, observer} from '@api'
import {useVipLocalStore} from '@modules'
import {CatalogFieldRenderer} from '@modules/CatalogItemDetails'
import {ModalDetailSection} from './ModalDetailSection'
import {LoadingIndicator} from '@modules/common'
import {useCatalogItemSidebarDetailsStore} from '@modules'
import {SecondarySection, useCatalog} from '@stores'
import {MouseEventHandler} from 'react'
import * as css from './CatalogSecondariesDetails.css'
import {DetailsSecondariesContext, DetailsSecondariesStore, useDetailsSecondariesStore} from './DetailsSecondaryStore'

// region Components

export const CatalogSecondariesDetails = observer(function CatalogSecondariesDetails() {
  const detailsStore = useCatalogItemSidebarDetailsStore(),
    store = useVipLocalStore((ws) => new DetailsSecondariesStore(ws, detailsStore)),
    {catalog: {settings: {detailLoc: align}}, strings, sections, tab, loading, secondaries} = store

  useEffect(() => {
    detailsStore && store._runSecondariesQuery()
  }, [detailsStore?.id, detailsStore?.data?.secondaries])

  if (!tab) return null

  return (
    <DetailsSecondariesContext.Provider value={store}>
      <div className={css.root} data-sidebar-align={align}>
        {sections?.length > 0
         ? sections.map((s, i) => <ModalDetailSection index={i} tabId={tab.id} section={s} key={i} headerExtra={<SecondariesHeaderExtra section={s}/>}/>)
        : loading ? <LoadingIndicator text={strings.loadingSecondaries} className={css.loadingSecondaries} /> :
          _.isEmpty(secondaries) ? <div className={css.noResults}>{strings.noSecondariesDataAvailable}</div>
          : null}
      </div>
    </DetailsSecondariesContext.Provider>
  )
})

const SecondariesHeaderExtra = observer<{ section: SecondarySection }>(function SecondariesHeaderExtra({section}) {
  const {tab: {secondariesTemplate}} = useDetailsSecondariesStore(),
    onDoubleClick = useCallback<MouseEventHandler>(e => {
      e.preventDefault()
      e.stopPropagation()
    }, [])
  if (!secondariesTemplate?.headerFields) return null

  const {headerFields} = secondariesTemplate

  return (
    <div className={css.headerExtra} onDoubleClick={onDoubleClick}>
      {headerFields.map((field, i) => <CatalogFieldRenderer field={field} key={i} section={section} />)}
    </div>
  )
})
//endregion




// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/CatalogSecondariesDetails.tsx